import { render } from "./HourComponent.vue?vue&type=template&id=66768008"
import script from "./HourComponent.vue?vue&type=script&lang=js"
export * from "./HourComponent.vue?vue&type=script&lang=js"

import "./HourComponent.vue?vue&type=style&index=0&id=66768008&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__